import React from 'react'
import Select from '../../basic/select'
import Button from '../../basic/button'
import {findElement, findLabel} from '../utils'
import Code from './code'
import styled from 'styled-components'
import {browserHistory} from 'react-router'
import LoaderLine from "../../basic/LoaderLine";
import MenuCloseButton from "../../static/menuCloseButton.svg";
import TranslateText from 'src/text/modal';

const Container = styled.div`
  display: flex;
  height: 55px;
  z-index: 10;
  background: #173DB0;
`

const Selection = styled.div`
  width: 50%;
  background: white;
  font-size: 12px;
  position: relative;
  outline: none;
  z-index: 10;

  & > button {
    outline: none;
    border: none;
    cursor: pointer;
    background: white;
    padding-left: 14px;
    color: #919191;
    text-align: initial;
    width: 100%;
    height: 100%;
  }
`

const Confs = styled.img`
  position: absolute;
  right: 20px;
  top: 22px;
  z-index: 1;
`

const Dropdown = styled.div`
  display: ${props => props.active === 'selection' ? 'block' : 'none'};
  position: absolute;
  right: 0;
  top: 100%;
  width: 100%;
  background: white;
  z-index: 2;

  & > * {
    display: block;
    margin: 10px;
  }
`

const Background = styled.div`
  display: ${props => props.active ? 'block' : 'none'};
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(30,67,156,.84);
`

const Option = styled.option`
  font-size: 18px;
  padding: 10px 20px 10px 10px;
  background: transparent;
`

const Search = ({
  active, setActive,
  menuShown, setMenuShown,
  article, setArticle,
  manufacture, setManufacture, manufactures,
  model, setModel, models,
  generation, setGeneration, generations,
  variant, setVariant, variants,
  engine, setEngine, engines,
  loadingManufactures, loadingGenerations, loadingModels, loadingVariants, loadingEngines
}) => {
  return (
    <div>
      <TranslateText
        hideTooltip={menuShown}
        id="open_search_small"
        style={{
          textAlign: 'center',
          background: 'rgb(23, 61, 176)',
          cursor: 'pointer',
        }}
        place="bottom"
        render={text => {
          return (
            <div
              style={{
                textAlign: 'center',
                background: 'rgb(23, 61, 176)',
                cursor: 'pointer',
              }}
              onClick={() => {
                setMenuShown(!menuShown)
              }}
            >
              <div
                style={{
                  display: 'inline-block',
                  height: 54,
                  lineHeight: '54px',
                  color: 'white',

                  fontSize: menuShown && 24,
                }}
              >
                {menuShown ? <img src={MenuCloseButton}/> : text}
              </div>
            </div>
          );
        }}
      />
      {
        menuShown && (
          <div
            style={{
              textAlign: 'initial',
            }}
          >
            <Code
              translateLabelPlace="top"
              active={active}
              value={article}
              onFocus={() => {
                setActive('code')
              }}
              onChange={(e) => {
                setArticle(e.target.value)
              }}
              style={{width: 'auto'}}
            />
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            {
              loadingManufactures ? <LoaderLine/>
                :
                <TranslateText
                  id="search__mark"
                  place="bottom"
                  render={text => {
                    return (
                      <Select
                        label={findLabel(manufactures, manufacture) || text}
                        value={manufacture}
                        onChange={(e) => {
                          const manufacture = findElement(manufactures, e.target.value)
                          setManufacture(manufacture)
                        }}
                        theme='mobile-search'
                      >
                        <Option value=''/>
                        {(manufactures || []).map(o => {
                          return <Option value={o.id} key={o.id}>{o.name}</Option>
                        })}
                      </Select>

                    );
                  }}
                />
            }
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            {
              loadingModels ? <LoaderLine/>
                :
                <TranslateText
                  id="search__model"
                  place="bottom"
                  render={text => {
                    return (
                      <Select
                        label={findLabel(models, model) || text}
                        value={model}
                        onChange={(e) => {
                          const model = findElement(models, e.target.value)
                          setModel(model)
                        }}
                        disabled={!manufacture}
                        theme='mobile-search'
                      >
                        <Option value=''/>
                        {(models || []).map(o => {
                          return <Option value={o.id} key={o.id}>{o.name}</Option>
                        })}
                      </Select>
                    );
                  }}
                />
            }
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            {
              loadingGenerations ? <LoaderLine/>
                :
                <TranslateText
                  id="search__generation"
                  place="bottom"
                  render={text => {
                    return (
                      <Select
                        label={findLabel(generations, generation) || text}
                        value={generation}
                        onChange={(e) => {
                          const generation = findElement(generations, e.target.value)
                          setGeneration(generation)
                        }}
                        disabled={!model}
                        theme='mobile-search'
                      >
                        <Option value=''/>
                        {(generations || []).map(o => {
                          return <Option value={o.id} key={o.id}>{o.name}</Option>
                        })}
                      </Select>
                    );
                  }}
                />
            }
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            {
              loadingVariants ? <LoaderLine/> :
                <TranslateText
                  id="search__year"
                  place="bottom"
                  render={text => {
                    return (
                      <Select
                        label={findLabel(variants, variant) || text}
                        value={variant}
                        onChange={(e) => {
                          const variant = findElement(variants, e.target.value)
                          setVariant(variant)
                        }}
                        disabled={!generation}
                        theme='mobile-search'
                      >
                        <Option value=''/>
                        {(variants || []).map(o => {
                          return <Option value={o.id} key={o.id}>{o.name}</Option>
                        })}
                      </Select>
                    );
                  }}
                />
            }
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            {
              loadingEngines ? <LoaderLine/> :
                <TranslateText
                  id="search__engine"
                  place="bottom"
                  render={text => {
                    return (
                      <Select
                        label={findLabel(engines, engine) || text}
                        value={engine}
                        onChange={(e) => {
                          const engine = findElement(engines, e.target.value)
                          setEngine(engine)
                        }}
                        disabled={!variant}
                        theme='mobile-search'
                      >
                        <Option value=''/>
                        {(engines || []).map(o => {
                          return <Option value={o.id} key={o.id}>{o.name}</Option>
                        })}
                      </Select>
                    );
                  }}
                />
            }
            <hr style={{margin: 0, borderColor: 'rgb(47, 84, 197)'}}/>
            <div style={{textAlign: 'center', background: 'rgb(23, 61, 176)', padding: '10px 0'}}>
              <TranslateText
                id="search__pick-up"
                style={{ width: '90%' }}
                place="bottom"
                render={text => {
                  return (
                    <Button
                      style={{
                        width: '90%',
                        background: 'rgb(239, 61, 47)',
                        ...(!variant && {cursor: 'not-allowed'})
                      }}
                      onClick={() => {
                        if (variant) {
                          browserHistory.push(`/selection?manufacturer_id=${manufacture}&model_id=${model}&generation_id=${generation}&variant_id=${variant}${engine ? `&engine_id=${engine}` : ''}`)
                          setMenuShown(!menuShown)
                        }
                      }}
                    >
                      {text}
                    </Button>
                  );
                }}
              />
            </div>
          </div>
        )
      }
    </div>
  )
}

export default Search




// WEBPACK FOOTER //
// ./src/finwhale/search/LessThan600.js